module.exports = __webpack_public_path__ + "img/linux-logo.71593d75.png";